import { Profile } from '@loyalty/shared-common/leaderboard-api-client';
import { ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { NameFormat, nameFormatters } from '../utils/naming';
import { ParticipantFrontendContext } from '../participant-frontend-context';

export function formatProfileName(
  profile: ProfileAttributes | Profile,
  nameFormat: NameFormat,
  context: ParticipantFrontendContext,
) {
  const { t } = context.i18n;

  return nameFormatters[nameFormat](profile) || t('profile.anonymous');
}
